/**
 * Custom Size Availability Updater v5
 * Works with both native Shopify variant picker and GLO Color Swatch app.
 */
(function() {
  'use strict';

  function getProductVariants() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.variants || [];
    }
    return [];
  }

  function getAvailableSizesForColor(selectedColor) {
    var variants = getProductVariants();
    if (!variants.length) return null;
    var availableSizes = new Set();
    variants.forEach(function(variant) {
      var publicTitle = variant.public_title || '';
      var parts = publicTitle.split(' / ');
      if (parts.length >= 2) {
        var variantSize = parts[0].trim();
        var variantColor = parts[parts.length - 1].trim();
        if (variantColor === selectedColor) {
          availableSizes.add(variantSize);
        }
      }
    });
    return availableSizes.size > 0 ? availableSizes : null;
  }

  // Update the native Shopify variant picker (hidden, but affects theme CSS)
  function updateNativePicker(variantPicker) {
    var fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;
    var sizeInputs = Array.from(fieldsets[0].querySelectorAll('input[type="radio"]'));
    var colorInputs = Array.from(fieldsets[1].querySelectorAll('input[type="radio"]'));
    var selectedColorInput = colorInputs.find(function(i) { return i.checked; });
    if (!selectedColorInput) return;
    var availableSizes = getAvailableSizesForColor(selectedColorInput.value);
    if (!availableSizes) return;
    sizeInputs.forEach(function(input) {
      input.dataset.optionAvailable = availableSizes.has(input.value) ? 'true' : 'false';
    });
  }

  // Update the GLO Color Swatch app's size items
  function updateGloSwatches() {
    // Find the currently selected color from GLO swatches
    var selectedColorItem = document.querySelector('.select-option.selected .attr-title-hover, .select-option [aria-checked="true"] .attr-title-hover');
    
    // Also try the native picker for the selected color
    var vp = document.querySelector('variant-picker');
    var selectedColor = null;
    if (vp) {
      var fieldsets = vp.querySelectorAll('fieldset');
      if (fieldsets.length >= 2) {
        var colorInputs = Array.from(fieldsets[1].querySelectorAll('input[type="radio"]'));
        var checked = colorInputs.find(function(i) { return i.checked; });
        if (checked) selectedColor = checked.value;
      }
    }
    
    if (!selectedColor) return;
    var availableSizes = getAvailableSizesForColor(selectedColor);
    if (!availableSizes) return;

    // Find all GLO size swatches
    var sizeItems = Array.from(document.querySelectorAll('.select-option[data-value]'));
    sizeItems.forEach(function(item) {
      var sizeValue = item.getAttribute('data-value') || (item.dataset && item.dataset.value);
      if (!sizeValue) return;
      
      // Only process if this looks like a size (not a color)
      // Check if it's in the size list (not color list)
      var sizeSpan = item.querySelector('.attr-title-hover');
      if (!sizeSpan) return;
      var sizeText = sizeSpan.textContent.trim();
      
      // Check if this is a size option by seeing if it matches variant sizes
      var allSizes = new Set();
      getProductVariants().forEach(function(v) {
        var parts = (v.public_title || '').split(' / ');
        if (parts.length >= 2) allSizes.add(parts[0].trim());
      });
      
      if (!allSizes.has(sizeText)) return;
      
      var isAvailable = availableSizes.has(sizeText);
      item.setAttribute('data-unavailable-for-color', isAvailable ? 'false' : 'true');
    });
  }

  function doUpdate() {
    var vp = document.querySelector('variant-picker');
    if (vp) updateNativePicker(vp);
    updateGloSwatches();
  }

  function scheduleUpdates() {
    doUpdate();
    setTimeout(doUpdate, 100);
    setTimeout(doUpdate, 500);
    setTimeout(doUpdate, 1500);
  }

  function initVariantPicker(variantPicker) {
    scheduleUpdates();
    variantPicker.addEventListener('change', function(e) {
      if (e.target && e.target.type === 'radio') {
        scheduleUpdates();
      }
    });
    variantPicker.addEventListener('variant:update', scheduleUpdates);
  }

  // Also listen for clicks on GLO color swatches
  document.addEventListener('click', function(e) {
    var gloItem = e.target.closest('.select-option');
    if (gloItem) {
      setTimeout(scheduleUpdates, 50);
      setTimeout(scheduleUpdates, 300);
      setTimeout(scheduleUpdates, 1000);
    }
  });

  function init() {
    document.querySelectorAll('variant-picker').forEach(initVariantPicker);
    scheduleUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VARIANT-PICKER') initVariantPicker(node);
        node.querySelectorAll && node.querySelectorAll('variant-picker').forEach(initVariantPicker);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
